import { ReactNode } from "react";
import { TagTone } from "./styles";

/** A small colored label; styled by TABLE_SX (`.bdc-tag.<tone>`), so it must sit inside it. */
export default function Tag({ tone, children }: Readonly<{ tone: TagTone; children: ReactNode }>) {
  return <span className={`bdc-tag ${tone}`}>{children}</span>;
}
